import { Tab, Tabs } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { FaPhoneAlt } from 'react-icons/fa'
import { IoChatbubbleEllipsesOutline, IoHomeOutline } from 'react-icons/io5'
import { BsBoxSeam } from 'react-icons/bs'
import { FiShoppingCart } from 'react-icons/fi'
import { useEffect } from 'react'
import jwtDecode from 'jwt-decode'
import { useDispatch } from 'react-redux'
import { setUserAndToken } from '../../../redux/actions/authentication'

export const MobileTabs = () => {

  const history = useHistory()

  const dispatch = useDispatch()

  const credentials = localStorage.getItem('credentials')
  
  useEffect(() => {
    if (credentials) {
      const parsedCredentials = JSON.parse(credentials)
      try {
        let user = jwtDecode(parsedCredentials.access_token)
        dispatch(setUserAndToken({ user }))
      } catch {
        localStorage.removeItem('credentials')
        history.push('/ingresar')
      }
    } else {
      history.push('/ingresar')
    }
    //eslint-disable-next-line
  }, [credentials])

  return (
    <Tabs
    className='w-full'
    style={{backgroundColor: 'white', borderTop: '4px solid #e7eaee'}}
    value={null}
    onChange={(e: any, newValue) => {
      console.log("NEW VALUE", newValue)
      history?.push(newValue)
      // if (newValue === 'recent') {
      //   history.push('/pago_en_linea')
      // } else {
      //   history.push('/privacy')
      // }
    }}
    aria-label="icon label tabs example"
  >
    <Tab icon={<IoHomeOutline size={30} />} label="Estadistícas" value={'/stats'} style={{width: '25%', fontSize: 12}} />
    <Tab icon={<BsBoxSeam size={30} />}  label="Inventario" value={'/inventory'} style={{width: '25%', fontSize: 12}} />
    <Tab icon={<FiShoppingCart size={30} />}  label="Ventas" value={'sales'} style={{width: '25%', fontSize: 12}} />
    <Tab icon={<IoChatbubbleEllipsesOutline size={30} />}  label="Chat IA" value={'chatIA'} style={{width: '25%', fontSize: 12}} />

  </Tabs>
  )
}